export const bigBorderRadius = '30px'
export const mediumBorderRadius = '15px'
export const smallBorderRadius = '10px'
export const tinyBorderRadius = '8px'
export const minBorderRadius = '5px'
export const noBorderRadius = '2px' // bad name! i know :)
